module.exports = __webpack_public_path__ + "img/drobnaratka_alpha.561157ab.png";